/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const OfferElementTypeDto = {
    DishPackages: 'DISH_PACKAGES',
    DrinkPackages: 'DRINK_PACKAGES',
    Transport: 'TRANSPORT',
    Decoration: 'DECORATION',
    Service: 'SERVICE',
    Equipment: 'EQUIPMENT',
} as const;

export type OfferElementTypeDto = typeof OfferElementTypeDto[keyof typeof OfferElementTypeDto];



